export default function salida() {
  return 0
}

export function getSalidas(state) {
  return state.salidas
}
